package com.wintermar.inspection.core.ui.component.button.variant

enum class ButtonVariant {
    SmallPrimary,
    MediumPrimary,
    LargePrimary,
    XLargePrimary,
    XXLargePrimary,

    SmallSecondary,
    MediumSecondary,
    LargeSecondary,
    XLargeSecondary,
    XXLargeSecondary,

    SmallOutline,
    MediumOutline,
    LargeOutline,
    XLargeOutline,
    XXLargeOutline,

    SmallGhost,
    MediumGhost,
    LargeGhost,
    XLargeGhost,
    XXLargeGhost,

    SmallDanger,
    MediumDanger,
    LargeDanger,
    XLargeDanger,
    XXLargeDanger,
}
